module.exports = __webpack_public_path__ + "img/chestnut_white_ba_list.2c5520b7.jpg";